// extracted by mini-css-extract-plugin
module.exports = {"title-modal":"_15fpQEBFrzL-e5MtxSoBAA","dialog":"W-LMnBMRL9ChkYf4TeZnp","danger":"jaxKM19qixQpJRNsetWir"};